// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rheology-actions {
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: flex-end;
}

.rheology-matrix {
  display: grid;
  grid-template-columns: 140px repeat(3, 220px);
  gap: 0.45rem 0.55rem;
  align-items: left;
}

.rheology-header {
  width: 100%;
  max-width: 220px;
  justify-self: center;
  text-align: center;
  font-size: 0.83rem;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #d9e2ec;
}

.row-label-column {
  width: 100%;
  max-width: 140px;
  justify-self: end;
  text-transform: none;
  text-align: right;
}

.rheology-row-label {
  width: 100%;
  max-width: 140px;
  justify-self: end;
  font-size: 0.82rem;
  color: #475569;
  font-weight: 600;
  text-align: right;
}

.rheology-cell {
  width: 100%;
  max-width: 220px;
  min-width: 0;
  display: flex;
  justify-content: center;
  justify-self: center;
}

.rheology-cell > input,
.rheology-reading-values {
  width: 100%;
}

.rheology-cell > input,
.rheology-reading-values > input,
.rheology-temp-cell > input {
  text-align: center;
}

.rheology-temp-cell {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.rheology-temp-cell > input {
  min-width: 0;
  width: auto;
  flex: 1 1 auto;
}

.rheology-f2-cell {
  align-items: center;
}

.rheology-f2-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  white-space: nowrap;
  font-size: 0.82rem;
  color: #1f2937;
}

.rheology-reading-values {
  display: flex;
  gap: 0.25rem;
  min-width: 0;
}

.rheology-reading-values > input {
  min-width: 0;
  flex: 1 1 0;
}

.rheology-f2-value[readonly] {
  background-color: #d9d9d9;
  color: #334155;
}

.rheology-high-reading {
  background-color: #f8d7da;
  border-color: #dc3545;
}

.rheology-temp-remove {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

@media (max-width: 680px) {
  .rheology-matrix {
    overflow-x: auto;
    display: block;
  }
  .rheology-matrix > * {
    min-width: 220px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-rheology-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,6CAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gCAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AACF;;AAEA;;EAEE,WAAA;AACF;;AAEA;;;EAGE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACE,gBAAA;IACA,cAAA;EACF;EAEA;IACE,gBAAA;EAAF;AACF","sourcesContent":[".rheology-actions {\n  margin-bottom: 0.5rem;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.rheology-matrix {\n  display: grid;\n  grid-template-columns: 140px repeat(3, 220px);\n  gap: 0.45rem 0.55rem;\n  align-items: left;\n}\n\n.rheology-header {\n  width: 100%;\n  max-width: 220px;\n  justify-self: center;\n  text-align: center;\n  font-size: 0.83rem;\n  font-weight: 700;\n  color: #334155;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  padding-bottom: 0.2rem;\n  border-bottom: 1px solid #d9e2ec;\n}\n\n.row-label-column {\n  width: 100%;\n  max-width: 140px;\n  justify-self: end;\n  text-transform: none;\n  text-align: right;\n}\n\n.rheology-row-label {\n  width: 100%;\n  max-width: 140px;\n  justify-self: end;\n  font-size: 0.82rem;\n  color: #475569;\n  font-weight: 600;\n  text-align: right;\n}\n\n.rheology-cell {\n  width: 100%;\n  max-width: 220px;\n  min-width: 0;\n  display: flex;\n  justify-content: center;\n  justify-self: center;\n}\n\n.rheology-cell > input,\n.rheology-reading-values {\n  width: 100%;\n}\n\n.rheology-cell > input,\n.rheology-reading-values > input,\n.rheology-temp-cell > input {\n  text-align: center;\n}\n\n.rheology-temp-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.rheology-temp-cell > input {\n  min-width: 0;\n  width: auto;\n  flex: 1 1 auto;\n}\n\n.rheology-f2-cell {\n  align-items: center;\n}\n\n.rheology-f2-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  white-space: nowrap;\n  font-size: 0.82rem;\n  color: #1f2937;\n}\n\n.rheology-reading-values {\n  display: flex;\n  gap: 0.25rem;\n  min-width: 0;\n}\n\n.rheology-reading-values > input {\n  min-width: 0;\n  flex: 1 1 0;\n}\n\n.rheology-f2-value[readonly] {\n  background-color: #d9d9d9;\n  color: #334155;\n}\n\n.rheology-high-reading {\n  background-color: #f8d7da;\n  border-color: #dc3545;\n}\n\n.rheology-temp-remove {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.test-detail-section {\n  border: 1px solid #e3e8ef;\n  border-radius: 4px;\n  padding: 0.65rem;\n  background: #ffffff;\n}\n\n.test-detail-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.65rem 1rem;\n}\n\n.test-detail-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.test-detail-label {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #555;\n  font-weight: 600;\n}\n\n@media (max-width: 680px) {\n  .rheology-matrix {\n    overflow-x: auto;\n    display: block;\n  }\n\n  .rheology-matrix > * {\n    min-width: 220px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
